import React, { useState, useEffect } from 'react';
import { BsInstagram, BsTwitter, BsLinkedin, BsGithub } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
import { client } from '../client';

const SocialMedia = () => {
  const [socialMedia, setSocialMedia] = useState([]);

  useEffect(() => {
    const query = '*[_type == "socialMedia"]';
    
    client.fetch(query).then((data) => {
      console.log('Social Media data:', data);
      setSocialMedia(data);
    }).catch(err => console.error('Social Media fetch error:', err));
  }, []);

  const getIcon = (platform) => {
    switch (platform) {
      case 'twitter': return <BsTwitter />;
      case 'facebook': return <FaFacebookF />;
      case 'instagram': return <BsInstagram />;
      case 'linkedin': return <BsLinkedin />;
      case 'github': return <BsGithub />;
      default: return <BsTwitter />;
    }
  };

  return (
    <div className="app__social">
      {socialMedia.length > 0 ? (
        socialMedia.map((item, index) => (
          <div key={index} className={`social-${item.platform}`}>
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              {getIcon(item.platform)}
            </a>
          </div>
        ))
      ) : (
        // Default fallback icons
        <>
          <div className="social-twitter"><BsTwitter /></div>
          <div className="social-facebook"><FaFacebookF /></div>
          <div className="social-instagram"><BsInstagram /></div>
          <div className="social-linkedin"><BsLinkedin /></div>
          <div className="social-github"><BsGithub /></div>
        </>
      )}
    </div>
  );
};

export default SocialMedia;
